import React, { memo, forwardRef } from "react";
import type { InputTextProps } from "../types";
import { InputWrapper } from "../styled-components";
import { InputField } from "../inputField";
import { InputLabel } from "../inputLabel";
import { InputMessage } from "../inputMessage";

export const InputText = forwardRef<HTMLInputElement, InputTextProps>(
  (
    {
      label = "",
      messageAbove = "",
      messageBellow = "",
      isOptional = false,
      isChecked = false,
      isInvalid = false,
      disabled = false,
      warningMessage = "",
      qaLabel,
      onBlur,
      onChange,
      onFocus,
      ...rest
    }: InputTextProps,
    ref
  ) => (
    <InputWrapper {...rest} data-qa-label={qaLabel}>
      <InputLabel label={label} isOptional={isOptional} isChecked={isChecked} />
      {!!messageAbove && (
        <InputMessage message={messageAbove} marginTop="space-3" />
      )}
      <InputField
        ref={ref}
        isInvalid={isInvalid}
        isDisabled={disabled}
        qaLabel={`${qaLabel}-input-field`}
        onBlur={onBlur}
        onChange={onChange}
        onFocus={onFocus}
        {...rest}
        type="text"
        my="space-2"
        mx={0}
        p={0}
      />
      {isInvalid && warningMessage && (
        <InputMessage
          message={warningMessage}
          isWarning={isInvalid}
          mx={0}
          mt={2}
          mb="space-3"
        />
      )}
      {!!messageBellow && <InputMessage message={messageBellow} />}
    </InputWrapper>
  )
);

export default memo(InputText);
